import { useEffect, useState } from 'react';
import Spinner from './Spinner';
import { Link } from 'react-router-dom';
import DisplayAd from './DisplayAd';
// import InarticleAd from './InarticleAd';
import MultiplexAd from './MultiplexAd';
import '../styles/SubHero.css';

function SubHero() {
  const formatDate = (timestamp) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const compareDates = (a, b) => {
    return new Date(b.date) - new Date(a.date);
  };

  const HOST = process.env.REACT_APP_HOST_NAME;
  const [quizes, setQuizes] = useState(null);
  const [articles, setArticles] = useState(null);
  const [latestUpdates, setLatestUpdates] = useState(null);
  const [studyMaterial, setStudyMaterial] = useState(null);

  const fetchQuizesData = async (page = 1, limit = 15) => {
    try {
      const response = await fetch(`${HOST}api/getallquizes?page=${page}&limit=${limit}`);
      const data = await response.json();
      if (response.ok) {
        const sortedData = data.quizzes.sort((a, b) => new Date(b.date) - new Date(a.date));
        if (sortedData.length < 2) {
          setQuizes(sortedData);
        } else {
          setQuizes(sortedData.slice(0, 2));
        }
      } else {
        console.error('Failed to fetch quizzes');
      }
    } catch (error) {
      console.error('Error fetching quizzes:', error);
    }
  };

  const fetchData = async (type) => {
    let url = "";
    if (type === 'articles') {
      url = 'articles';
    } else if (type === 'quizes') {
      url = 'getallquizes';
    } else if (type === 'latestupdate') {
      url = 'get-all-updates';
    } else if (type === 'study_material') {
      url = 'getallmaterial';
    }

    try {
      const response = await fetch(`${HOST}api/${url}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      const sortedData = data.sort(compareDates);

      if (type === 'articles') {
        setArticles(sortedData.length < 2 ? sortedData : sortedData.slice(0, 2));
      } else if (type === 'quizes') {
        setQuizes(sortedData.length < 2 ? sortedData : sortedData.slice(0, 2));
      } else if (type === 'latestupdate') {
        setLatestUpdates(sortedData.length < 2 ? sortedData : sortedData.slice(0, 2));
      } else if (type === 'study_material') {
        setStudyMaterial(sortedData.length < 2 ? sortedData : sortedData.slice(0, 2));
      }
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
    }
  };

  useEffect(() => {
    fetchData('articles');
    fetchQuizesData();
    fetchData('study_material');
    fetchData('latestupdate');
  }, []);

  return (
    <div className="subhero-wrapper">
      <DisplayAd />

      {/* ════════════════════════════════════════════════════════════
          ★ TYPING PRACTICE PROMO SECTION
          Placed between Test Series and Current Affairs
      ════════════════════════════════════════════════════════════ */}
      <section className="content-section typing-promo-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon">⌨️</span>
            Typing Practice
          </h2>
          <div className="title-underline"></div>
        </div>

        <div className="container">
          {/* ── Main Promo Banner ── */}
          <div className="typing-promo-banner">

            {/* Left: text content */}
            <div className="typing-promo-left">
              <div className="typing-promo-badge">
                <span>🏛️ Bombay High Court Pattern</span>
              </div>
              <h3 className="typing-promo-title">
                Master Typing for Court Exams
              </h3>
              <p className="typing-promo-desc">
                Practice with real exam-style paragraphs in{' '}
                <strong>English</strong> and <strong>Marathi</strong>.
                Track your WPM, accuracy, and errors in real time.
              </p>

              {/* Feature pills */}
              <div className="typing-promo-features">
                <span className="typing-promo-feature">
                  <span className="feature-icon">📝</span>
                  Practice Mode
                </span>
                <span className="typing-promo-feature">
                  <span className="feature-icon">🎯</span>
                  Test Mode
                </span>
                <span className="typing-promo-feature">
                  <span className="feature-icon">🇮🇳</span>
                  Marathi Support
                </span>
                <span className="typing-promo-feature">
                  <span className="feature-icon">📊</span>
                  Live Stats
                </span>
              </div>

              {/* CTA buttons */}
              <div className="typing-promo-actions">
                <Link to="/typing-practice" className="typing-promo-btn-primary">
                  <span>⌨️</span>
                  Start Typing Practice
                  <span className="btn-arrow">→</span>
                </Link>
                <Link to="/typing-practice" className="typing-promo-btn-secondary">
                  <span>🧪</span>
                  Take a Test
                </Link>
              </div>
            </div>

            {/* Right: stats showcase */}
            <div className="typing-promo-right">
              <div className="typing-promo-stats-grid">

                <div className="typing-promo-stat-card">
                  <span className="promo-stat-icon">⚡</span>
                  <span className="promo-stat-value">WPM</span>
                  <span className="promo-stat-label">Words Per Minute</span>
                </div>

                <div className="typing-promo-stat-card">
                  <span className="promo-stat-icon">🎯</span>
                  <span className="promo-stat-value">Accuracy</span>
                  <span className="promo-stat-label">Error Tracking</span>
                </div>

                <div className="typing-promo-stat-card">
                  <span className="promo-stat-icon">🇬🇧</span>
                  <span className="promo-stat-value">English</span>
                  <span className="promo-stat-label">Full Support</span>
                </div>

                <div className="typing-promo-stat-card">
                  <span className="promo-stat-icon">🇮🇳</span>
                  <span className="promo-stat-value">Marathi</span>
                  <span className="promo-stat-label">Full Support</span>
                </div>

              </div>

              {/* Fake typing preview */}
              <div className="typing-promo-preview">
                <div className="preview-bar">
                  <span className="preview-dot red"></span>
                  <span className="preview-dot yellow"></span>
                  <span className="preview-dot green"></span>
                  <span className="preview-label">Live Practice</span>
                </div>
                <div className="preview-text">
                  <span className="preview-char correct">T</span>
                  <span className="preview-char correct">h</span>
                  <span className="preview-char correct">e</span>
                  <span className="preview-char correct"> </span>
                  <span className="preview-char correct">H</span>
                  <span className="preview-char correct">i</span>
                  <span className="preview-char correct">g</span>
                  <span className="preview-char correct">h</span>
                  <span className="preview-char correct"> </span>
                  <span className="preview-char incorrect">C</span>
                  <span className="preview-char pending">o</span>
                  <span className="preview-char pending">u</span>
                  <span className="preview-char pending">r</span>
                  <span className="preview-char pending">t</span>
                  <span className="preview-char pending"> </span>
                  <span className="preview-char pending">e</span>
                  <span className="preview-char pending">x</span>
                  <span className="preview-char pending">a</span>
                  <span className="preview-char pending">m</span>
                  <span className="preview-char pending">.</span>
                </div>
                <div className="preview-footer">
                  <span className="preview-stat">
                    <strong>42</strong> WPM
                  </span>
                  <span className="preview-stat">
                    <strong>96%</strong> Accuracy
                  </span>
                  <span className="preview-stat">
                    <strong>2</strong> Errors
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Test Series Section */}
      <section className="content-section test-series-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon">📝</span>
            Test Series {new Date().getFullYear()}
          </h2>
          <div className="title-underline"></div>
        </div>

        {!quizes ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row g-4">
              {quizes.map((quiz, index) => (
                <div className="col-lg-4 col-md-6" key={quiz._id}>
                  <div className="content-card quiz-card" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="card-image-wrapper">
                      <img
                        src="https://res.cloudinary.com/dde4uttp5/image/upload/v1767805760/shared_image_10_q2gsfk.jpg"
                        className="card-image"
                        alt="Test Series"
                      />
                      <div className="card-badge quiz-badge">Test</div>
                    </div>
                    <div className="card-content">
                      <div className="quiz-info">
                        {/* <div className="info-item"> */}
                          <span className="info-label">Date:</span>
                          <span className="info-value">{formatDate(quiz.date)}</span>
                        {/* </div> */}
                        {/* <div className="info-item"> */}
                          <span className="info-label">Subject:</span>
                          <span className="info-value">{quiz.caption}</span>
                        {/* </div> */}
                      </div>
                      <Link className="card-btn quiz-btn" to={`/start/${quiz._id}`}>
                        <span className="btn-icon">🚀</span>
                        Start Test
                        <span className="btn-arrow">→</span>
                      </Link>
                      <p className="card-meta">
                        <span className="meta-icon">📅</span>
                        {formatDate(quiz.date)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              {quizes.length > 0 && (
                <div className="col-lg-4 col-md-6" key="viewall-quizes">
                  <Link to="/allquizes" className="view-more-card">
                    <div className="content-card view-more">
                      <div className="card-image-wrapper">
                        <img
                          src="https://res.cloudinary.com/dde4uttp5/image/upload/v1767805760/shared_image_10_q2gsfk.jpg"
                          className="card-image"
                          alt="View More"
                        />
                        <div className="view-more-overlay">
                          <div className="view-more-content">
                            <span className="view-more-icon">👁️</span>
                            <h3 className="view-more-text">View All Tests</h3>
                            <span className="view-more-arrow">→</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </section>

      {/* <InarticleAd /> */}

      {/* Current Affairs Section */}
      <section className="content-section articles-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon">📰</span>
            Current Affairs
          </h2>
          <div className="title-underline"></div>
        </div>

        {!articles ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row g-4">
              {articles.map((article, index) => (
                <div className="col-lg-4 col-md-6" key={article._id}>
                  <div className="content-card article-card" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="card-image-wrapper">
                      <img
                        src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720804925/dailycurrafair_uga0y3.jpg"
                        className="card-image"
                        alt="Current Affairs"
                      />
                      <div className="card-badge article-badge">Article</div>
                    </div>
                    <div className="card-content">
                      <Link to={`/article/${article._id}`} className="card-title-link">
                        <h5 className="card-title">{article.heading}</h5>
                      </Link>
                      <p className="card-description">
                        {article.text.length <= 80
                          ? article.text
                          : article.text.substring(0, 80) + "..."}
                      </p>
                      <Link to={`/article/${article._id}`} className="card-btn">
                        Read More
                        <span className="btn-arrow">→</span>
                      </Link>
                      <p className="card-meta">
                        <span className="meta-icon">📅</span>
                        {formatDate(article.date)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              {articles.length > 0 && (
                <div className="col-lg-4 col-md-6" key="viewall-articles">
                  <Link to="/articles" className="view-more-card">
                    <div className="content-card view-more">
                      <div className="card-image-wrapper">
                        <img
                          src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720804925/dailycurrafair_uga0y3.jpg"
                          className="card-image"
                          alt="View More"
                        />
                        <div className="view-more-overlay">
                          <div className="view-more-content">
                            <span className="view-more-icon">👁️</span>
                            <h3 className="view-more-text">View All Articles</h3>
                            <span className="view-more-arrow">→</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </section>

      {/* Study Material Section */}
      <section className="content-section study-material-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon">📚</span>
            E-books and Study Material
          </h2>
          <div className="title-underline"></div>
        </div>

        {!studyMaterial ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row g-4">
              {studyMaterial.map((material, index) => (
                <div className="col-lg-4 col-md-6" key={material._id}>
                  <div className="content-card material-card" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="card-image-wrapper">
                      <img
                        src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720805005/studymaterial_jervxl.jpg"
                        className="card-image"
                        alt="Study Material"
                      />
                      <div className="card-badge material-badge">PDF</div>
                    </div>
                    <div className="card-content">
                      <h5 className="card-title">{material.headline}</h5>
                      <div className="material-actions">
                        <a
                          href={material.contentViewUrl}
                          className="card-btn material-btn view-btn"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="btn-icon">👁️</span>
                          View PDF
                        </a>
                        <a
                          href={material.contentUrl}
                          className="card-btn material-btn download-btn"
                        >
                          <span className="btn-icon">⬇️</span>
                          Download
                        </a>
                      </div>
                      <p className="card-meta">
                        <span className="meta-icon">📅</span>
                        {formatDate(material.date)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              {studyMaterial.length > 0 && (
                <div className="col-lg-4 col-md-6" key="viewall-material">
                  <Link to="/ebooks" className="view-more-card">
                    <div className="content-card view-more">
                      <div className="card-image-wrapper">
                        <img
                          src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720805005/studymaterial_jervxl.jpg"
                          className="card-image"
                          alt="View More"
                        />
                        <div className="view-more-overlay">
                          <div className="view-more-content">
                            <span className="view-more-icon">👁️</span>
                            <h3 className="view-more-text">View All Materials</h3>
                            <span className="view-more-arrow">→</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </section>

            {/* Latest Updates Section */}
      <section className="content-section">
        <div className="section-header">
          <h2 className="section-title">
            <span className="title-icon">🔔</span>
            Latest Updates
          </h2>
          <div className="title-underline"></div>
        </div>

        {!latestUpdates ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row g-4">
              {latestUpdates.map((update, index) => (
                <div className="col-lg-4 col-md-6" key={update._id}>
                  <div className="content-card" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="card-image-wrapper">
                      <img
                        src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720804964/latest_updates_aq4tlu.jpg"
                        className="card-image"
                        alt="Latest Update"
                      />
                      <div className="card-badge update-badge">Update</div>
                    </div>
                    <div className="card-content">
                      <Link to={`/latest-update/${update._id}`} className="card-title-link">
                        <h5 className="card-title">{update.headline}</h5>
                      </Link>
                      <p className="card-description">
                        {update.mainText.length <= 80
                          ? update.mainText
                          : update.mainText.substring(0, 80) + "..."}
                      </p>
                      <Link to={`/latest-update/${update._id}`} className="card-btn">
                        Read More
                        <span className="btn-arrow">→</span>
                      </Link>
                      <p className="card-meta">
                        <span className="meta-icon">📅</span>
                        {formatDate(update.date)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              {latestUpdates.length > 0 && (
                <div className="col-lg-4 col-md-6" key="viewall-updates">
                  <Link to="/latest-updates" className="view-more-card">
                    <div className="content-card view-more">
                      <div className="card-image-wrapper">
                        <img
                          src="https://res.cloudinary.com/dzpazaufa/image/upload/v1720804964/latest_updates_aq4tlu.jpg"
                          className="card-image"
                          alt="View More"
                        />
                        <div className="view-more-overlay">
                          <div className="view-more-content">
                            <span className="view-more-icon">👁️</span>
                            <h3 className="view-more-text">View All Updates</h3>
                            <span className="view-more-arrow">→</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </section>


      <MultiplexAd />
    </div>
  );
}

export default SubHero;